import { defineStore } from "pinia"
import { cloneDeep } from "lodash"

export const useGFStore = defineStore("gfServe", {
  state: () => ({
    cacheLog: undefined
  }),
  actions: {
    // 清除缓存
    clearCache() {
      this.cacheLog = undefined
    },
    // 更新缓存
    saveCache(data) {
      this.cacheLog = cloneDeep(data)
    },
    // 更新 技术成果
    updateAchievement(index, achievement) {
      this.cacheLog.achievements[index] = cloneDeep(achievement)
    },
    // 获取技术成果
    getAchievement(index) {
      if (this.cacheLog) {
        const { achievements } = this.cacheLog
        return cloneDeep(
          achievements[index] || {
            name: "",
            achievementType: "1",
            files: []
          }
        )
      } else {
        return {
          name: "",
          achievementType: "2",
          files: []
        }
      }
    }
  }
})
